import { render } from "./PageHeaders.vue?vue&type=template&id=3ed56cb4"
import script from "./PageHeaders.vue?vue&type=script&lang=js"
export * from "./PageHeaders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__